import { tender360Api } from "./tender360Api";
import { tender360Store } from "./tender360Store";

export const TENDER360_FORCE_REFRESH_KEY = "__tender360ForceRefresh";

function readScopeKey() {
  if (typeof window === "undefined") return "ssr";
  try {
    const userId =
      window.localStorage.getItem("user_id") ||
      window.localStorage.getItem("userId") ||
      "guest";
    return String(userId).trim() || "guest";
  } catch (_error) {
    return "guest";
  }
}

export function markTender360ForceRefresh(payload = {}) {
  return {
    ...(payload && typeof payload === "object" ? payload : {}),
    [TENDER360_FORCE_REFRESH_KEY]: true,
  };
}

export function splitTender360RequestMeta(payload) {
  if (!payload || typeof payload !== "object" || Array.isArray(payload)) {
    return { payload, forceRefetch: false };
  }

  const {
    [TENDER360_FORCE_REFRESH_KEY]: forceRefetch,
    ...cleanPayload
  } = payload;
  return { payload: cleanPayload, forceRefetch: forceRefetch === true };
}

export async function cachedTender360Request(config = {}, options = {}) {
  const method = String(config.method || "post").toLowerCase();
  const requestData = splitTender360RequestMeta(config.data);
  const forceRefetch =
    options.forceRefetch === true || requestData.forceRefetch === true;

  const endpoint = options.lookup
    ? tender360Api.endpoints.lookupRequest
    : tender360Api.endpoints.request;
  const request = tender360Store.dispatch(
    endpoint.initiate(
      {
        method,
        url: config.url,
        data: requestData.payload,
        params: config.params,
        scopeKey: options.scopeKey || readScopeKey(),
      },
      {
        subscribe: false,
        forceRefetch,
      },
    ),
  );

  try {
    const data = await request.unwrap();
    return { data };
  } catch (error) {
    const wrappedError = new Error(
      error?.message || error?.data?.message || "Tender 360 request failed",
    );
    wrappedError.code = error?.status;
    wrappedError.response = {
      status: error?.status,
      data: error?.data,
    };
    throw wrappedError;
  }
}

export const cachedTender360Post = (url, data, options) =>
  cachedTender360Request({ method: "post", url, data }, options);

export const cachedTender360Get = (url, params, options) =>
  cachedTender360Request({ method: "get", url, params }, options);

export const cachedTender360LookupPost = (url, data, params) =>
  cachedTender360Request(
    { method: "post", url, data, params },
    { lookup: true },
  );

export const cachedTender360LookupGet = (url, params) =>
  cachedTender360Request(
    { method: "get", url, params },
    { lookup: true },
  );
